<template>
  <div
    dir="rtl"
    class="arad-surface auth-shell relative min-h-screen overflow-hidden"
  >
    <div class="grid min-h-screen lg:grid-cols-2">
      <aside class="auth-shell__glow relative hidden flex-col justify-between p-10 text-white lg:flex">
        <div
          class="pointer-events-none absolute inset-0"
          aria-hidden="true"
          style="
            background:
              radial-gradient(ellipse 80% 50% at 80% 0%, rgb(37 99 235 / 0.55), transparent 55%),
              linear-gradient(160deg, #0f172a 0%, #1e3a8a 55%, #2563eb 100%);
          "
        />
        <div class="auth-shell__brand relative z-10">
          <NuxtLink
            to="/"
            class="inline-flex items-center gap-3 text-white no-underline"
          >
            <span class="flex size-11 items-center justify-center rounded-xl bg-white/15 backdrop-blur">
              <UIcon
                name="i-lucide-sparkles"
                class="size-5"
              />
            </span>
            <span class="text-xl font-bold">AradCore</span>
          </NuxtLink>
        </div>
        <div class="relative z-10 max-w-md space-y-8">
          <div class="space-y-3">
            <h2 class="text-3xl font-bold leading-snug">
              سایت پزشکی‌تان را در چند دقیقه بسازید
            </h2>
            <p class="text-sm leading-relaxed text-white/75">
              طراحی، دامنه، اشتراک و پشتیبانی — همه در یک پنل فارسی و راست‌به‌چپ.
            </p>
          </div>
          <ul class="space-y-4 text-sm">
            <li
              v-for="item in benefits"
              :key="item.title"
              class="flex gap-3"
            >
              <span class="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg bg-white/15">
                <UIcon
                  :name="item.icon"
                  class="size-4"
                />
              </span>
              <span>
                <span class="block font-semibold">{{ item.title }}</span>
                <span class="text-white/70">{{ item.text }}</span>
              </span>
            </li>
          </ul>
        </div>
        <p class="relative z-10 text-xs text-white/60">
          چندین کلینیک و مطب در حال ساخت سایت با آرادکور
        </p>
      </aside>

      <section class="auth-shell__glow relative flex min-h-screen flex-col">
        <header class="auth-shell__brand relative z-10 mx-auto flex w-full max-w-lg flex-col gap-3 px-4 pt-6 sm:pt-8">
          <div class="flex w-full items-center justify-between gap-2">
            <UButton
              to="/"
              color="neutral"
              variant="ghost"
              size="sm"
              icon="i-lucide-chevron-right"
              class="shrink-0 font-medium"
            >
              بازگشت
            </UButton>
            <div class="ms-auto">
              <AppColorModeToggle />
            </div>
          </div>
          <NuxtLink
            to="/"
            class="group flex items-center gap-2 self-start no-underline lg:hidden"
          >
            <span class="flex size-9 items-center justify-center rounded-xl bg-primary text-white shadow-md shadow-primary/25">
              <UIcon
                name="i-lucide-sparkles"
                class="size-4"
              />
            </span>
            <span class="text-lg font-bold tracking-tight text-[var(--ui-text)]">
              AradCore
            </span>
          </NuxtLink>
        </header>

        <main class="relative z-10 flex flex-1 items-center justify-center px-4 py-10 sm:py-14">
          <div class="auth-shell__panel w-full max-w-md rounded-2xl border border-[var(--ui-border)] bg-[var(--ui-bg)]/90 p-6 shadow-xl shadow-slate-900/5 backdrop-blur-sm sm:p-8">
            <slot />
          </div>
        </main>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
usePersianLayout()

const benefits = [
  { icon: 'i-lucide-palette', title: 'بیلدر بصری', text: 'صفحات سایت را بدون کدنویسی بچینید.' },
  { icon: 'i-lucide-globe', title: 'زیردامنه رایگان', text: 'با یک نام، سایت‌تان روی آرادکور منتشر می‌شود.' },
  { icon: 'i-lucide-life-buoy', title: 'پشتیبانی تیکتی', text: 'سوال مالی، فنی یا توسعه را مستقیم بپرسید.' },
]
</script>
